import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {usePipelineTemplates} from '../hooks/usePipelineTemplates.ts';
import {usePipelineTemplatesFilter} from '../hooks/usePipelineTemplatesFilter.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {usePipelineTemplatesSelection} from '../hooks/usePipelineTemplatesSelection.ts';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {usePipelineTemplatesSearch} from "../hooks/usePipelineTemplatesSearch.ts";
import {usePipelineTemplatesTableColumns} from "../hooks/usePipelineTemplatesTableColumns.tsx";
import {rbacActions} from "../../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from "../../../../components/DataTableTokenPagination";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {filters} = usePipelineTemplatesFilter();

    const {
        visibleItems: records,
        loading,
        nextToken,
        fetchNextPage,
    } = usePipelineTemplates(filters);

    const {
        columns,
    } = usePipelineTemplatesTableColumns();

    const {
        handleFilterByKeyword,
    } = usePipelineTemplatesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = usePipelineTemplatesSelection();

    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeletePipelineTemplate)) {
        selectedRecords = records.filter(record => selection[record.id])
    }

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.id, true)
                    })
                }}
                fetching={loading}
                onScrollToBottom={() => fetchNextPage()}
                scrollViewportRef={scrollViewportRef}
            />

            <DataTableTokenPagination
                totalCount={records.length.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchNextPage}
            />
        </Stack>
    );
};
